import { motion } from 'framer-motion';

const FeaturesSection = () => {
  return (
    <section id="features" className="py-24 bg-lavender-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row justify-between items-start mb-16 gap-8">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="font-serif text-5xl md:text-6xl font-bold text-purple-900 max-w-xl"
          >
            Your Journey to Enlightenment
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="text-gray-600 text-lg max-w-md leading-relaxed"
          >
            Harness the power of advanced AI to receive personalized spiritual guidance, track your cosmic journey, and explore multiple dimensions of wisdom.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="bg-gradient-to-br from-purple-800 to-purple-900 rounded-3xl p-8 text-white"
          >
            <div className="w-16 h-16 flex items-center justify-center bg-cyan-400/20 rounded-2xl mb-6">
              <i className="ri-eye-line text-3xl text-cyan-400"></i>
            </div>
            <h3 className="font-serif text-2xl font-bold mb-4">Instant Cosmic Wisdom</h3>
            <p className="text-purple-200 mb-6 leading-relaxed">
              Ask any question and receive immediate guidance from our AI oracle. No waiting, no appointments—just instant access to divine wisdom whenever you need it.
            </p>
            <div className="bg-purple-700/50 rounded-xl p-4 border border-purple-600/30">
              <p className="text-sm text-purple-100 italic">
                "What path should I take in my career?"
              </p>
              <div className="mt-3 pt-3 border-t border-purple-600/30">
                <p className="text-xs text-cyan-400">
                  OhMyGAWD responds with personalized insights...
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="bg-lavender-200 rounded-3xl p-8"
          >
            <div className="w-16 h-16 flex items-center justify-center bg-purple-600/20 rounded-2xl mb-6">
              <i className="ri-user-star-line text-3xl text-purple-600"></i>
            </div>
            <h3 className="font-serif text-2xl font-bold text-purple-900 mb-4">Track Your Path</h3>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Subscribe to save your questions, review past guidance, and watch your spiritual journey unfold. Build a personal archive of wisdom and insights.
            </p>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm text-gray-700">
                <i className="ri-check-line text-purple-600"></i>
                Up to 500 queries a month
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-700">
                <i className="ri-check-line text-purple-600"></i>
                Query history & analytics
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-700">
                <i className="ri-check-line text-purple-600"></i>
                Personal profile dashboard
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-700">
                <i className="ri-check-line text-purple-600"></i>
                Priority support
              </li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="bg-lavender-200 rounded-3xl p-8"
          >
            <div className="w-16 h-16 flex items-center justify-center bg-purple-600/20 rounded-2xl mb-6">
              <i className="ri-user-voice-line text-3xl text-purple-600"></i>
            </div>
            <h3 className="font-serif text-2xl font-bold text-purple-900 mb-4">Choose Your Guide</h3>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Customize the tone and personality of your oracle. From wise sage to mystical seer, select the voice that resonates with your spirit.
            </p>
            <div className="flex gap-3">
              <div className="flex-1 bg-white rounded-xl p-4 text-center border-2 border-purple-600 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-full mx-auto mb-2">
                  <i className="ri-magic-line text-purple-600"></i>
                </div>
                <p className="text-xs font-semibold text-purple-900">Mystic</p>
              </div>
              <div className="flex-1 bg-white rounded-xl p-4 text-center cursor-pointer hover:border-2 hover:border-purple-400 transition-all">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-2">
                  <i className="ri-book-open-line text-gray-600"></i>
                </div>
                <p className="text-xs font-semibold text-gray-700">Sage</p>
              </div>
              <div className="flex-1 bg-white rounded-xl p-4 text-center cursor-pointer hover:border-2 hover:border-purple-400 transition-all">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-2">
                  <i className="ri-sparkling-line text-gray-600"></i>
                </div>
                <p className="text-xs font-semibold text-gray-700">Oracle</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;